"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XalHttpRequest = void 0;

var http_1 = require("@xbox/http");

var RequestSigner_1 = require("./RequestSigner");

var Utils_1 = require("./Utils");

var XalHttpRequest =
/** @class */
function () {
  function XalHttpRequest(httpClient, method, url) {
    this.httpClient = httpClient;
    this.request = {
      method: method,
      url: url
    };
  }

  XalHttpRequest.buildAuthorizationHeader = function (xTokenData) {
    Utils_1.assert(xTokenData.xerr === 0); // TODO(alkhayat): NOXAL: This isn't yet implemented in XAL, there's no user hash in anonymous scenarios
    // assert(!!xTokenData.userHash);

    Utils_1.assert(!!xTokenData.token); // TODO(alkhayat): NOXAL: This isn't yet implemented in XAL, when there's no user hash, use - for no user

    var userHash = xTokenData.userHash ? xTokenData.userHash : "-"; // Header value format from http://xboxwiki/wiki/XBL3.0_Protocol

    return "XBL3.0 x=" + userHash + ";" + xTokenData.token;
  };

  XalHttpRequest.prototype.setHeader = function (key, value) {
    var newHeader = {
      Name: key,
      Value: value
    };

    if (this.request.headers) {
      this.request.headers.push(newHeader);
    } else {
      this.request = __assign(__assign({}, this.request), {
        headers: [newHeader]
      });
    }

    return this;
  };

  XalHttpRequest.prototype.setBody = function (body) {
    this.request.data = body;
    return this;
  };

  XalHttpRequest.prototype.setSignature = function (value) {
    this.setHeader("Signature", value);
    return this;
  };

  XalHttpRequest.prototype.setAuthorization = function (value) {
    this.setHeader("Authorization", value);
    return this;
  };

  XalHttpRequest.prototype.setAuthorizationWithXtoken = function (xTokenData) {
    var authHeaderValue = XalHttpRequest.buildAuthorizationHeader(xTokenData);
    return this.setAuthorization(authHeaderValue);
  };

  XalHttpRequest.prototype.signRequest = function (ecdsa, signaturePolicy) {
    return __awaiter(this, void 0, void 0, function () {
      var url, signature;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = new http_1.Url(this.request.url);
            return [4
            /*yield*/
            , RequestSigner_1.RequestSigner.signRequest(ecdsa, signaturePolicy, this.request.method, "" + url.pathname + url.search, this.request.headers, this.request.data)];

          case 1:
            signature = _a.sent();
            this.setSignature(signature);
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  XalHttpRequest.prototype.execute = function () {
    return this.httpClient.sendRequest(this.request, function (status) {
      return status < 500 || status >= 600;
    });
  };

  return XalHttpRequest;
}();

exports.XalHttpRequest = XalHttpRequest;